import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Spinner, Table } from "react-bootstrap";
import { Paper } from "@material-ui/core";
import { baseUrl } from "../../../services/config";
import { useAlert } from "react-alert";
import ReactToPrint from "react-to-print";
import MultiStudentFeeChallan from "../MultiStudentFeeChallan/MultiStudentFeeChallan";

const SingleStudentMonth = () => {
  const authtoken = localStorage.getItem("userToken");
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user.user);
  const [campuses, setallcampuses] = useState(user.campuses || []);
  const [searchStudentLoading, setSearchStudentLoading] = useState(false);
  const [fee_month, setfee_month] = useState("");
  const [searchtext, setsearchtext] = useState("");
  const alert = useAlert();

  const [allsessions, setallsessions] = useState([]);
  const [currentSession, setCurrentSession] = useState("");
  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);
  const [classSectionData, setClassSectionData] = useState([]);

  const [campusId, setCampusId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [allstudentList, setallstudentsList] = useState([]);

  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");

  const [blankPage, setBlankPage] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const pageStyle = `
  @page {
    size:letter landscape !important;
  }
  `;

  const [selectedChallans, setSelectedChallans] = useState([]);
  const [mainCheckBoxChecked, setmaincheckboxChecked] = useState(false);
  const searchClicked = useRef(false);
  const banksloaded = useRef(false);

  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);

  useEffect(() => {
    if (!banksloaded.current) {
      banksloaded.current = true;
      getAllSessions();
    }

    if (searchClicked.current) {
      searchClicked.current = false;
      setAllCheckboxes(true);
    } else {
      checkAllCheckBoxes();
    }
  }, [[], selectedChallans]);

  const getMonthName = (date) => {
    if (date == "") {
      return "_";
    }
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const d = new Date(date);

    return `${monthNames[d.getMonth()]}-${d.getFullYear()}`;
  };

  const getAllSessions = () => {
    fetch(`${baseUrl}/session`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallsessions(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_academic_year == "1") {
            setCurrentSession(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onCampusChange = (id) => {
    setCampusId(id);
    getCampusCourses(id);
  };

  const getCampusCourses = (id) => {
    if (id == "") {
      return alert.error("Please Select Campus");
    }
    fetch(`${baseUrl}/campus-all-courses/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCampusCourseData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onCourseChange = (id) => {
    setCourseId(id);
    getCourseClasses(id);
  };

  const getCourseClasses = (id) => {
    if (id == "") {
      return alert.error("Please Select Course");
    }
    fetch(`${baseUrl}/course-all-classes/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseClassData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const onClassChange = (id) => {
    setClassId(id);
    getSectionsList(id);
  };

  const getSectionsList = (id) => {
    if (id == "" || campusId == "" || courseId == "") {
      alert.error("Please Select Campus / Course/ Class");
      return;
    }
    fetch(`${baseUrl}/class-section/${campusId}/${courseId}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassSectionData(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const searchChallans = () => {
    if (currentSession == "") {
      alert.error("Please Select Session");
      return;
    }

    if (campusId == "") {
      alert.error("Please Select Campus");
      return;
    }

    if (courseId == "") {
      alert.error("Please Select Course");
      return;
    }

    if (classId == "") {
      alert.error("Please Select Class");
      return;
    }

    if (sectionId == "") {
      alert.error("Please Select Section");
      return;
    }

    if (fee_month == "") {
      alert.error("Please Select Section");
      return;
    }

    setLoading(true);

    const data = {
      year_id: currentSession,
      campus_id: campusId,
      course_id: courseId,
      student_class_id: classId,
      global_section_id: sectionId,
      fee_month: `${fee_month}-01`,
      fee_status: 0,
    };
    fetch(`${baseUrl}/fee_challan_month_wise`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          if (data.payload.students.length == 0) {
            alert.error("Student Record Not Found");
            setSelectedChallans([]);
            setallstudentsList([]);
            setLoading(false);
            return;
          }

          searchClicked.current = true;
          setallstudentsList(data.payload.students);
          setLoading(false);
          setShowResult(true);
        } else if (!data.metadata.success) {
          Object.values(data.metadata.message).map((msg) => {
            alert.error(msg[0]);
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const searchbyAdmId = (e) => {
    e.preventDefault();
    if (searchtext == "") {
      alert.error("Please enter Admission Id or Name");
      return;
    }
    if (fee_month == "") {
      alert.error("Please Select Month");
      return;
    }
    setSearchStudentLoading(true);
    const data = {
      search_keyword: searchtext.toLocaleUpperCase(),
    };

    fetch(`${baseUrl}/search_by_name_or_adm_id`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },

      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          if (data.payload.length == 0) {
            setSearchStudentLoading(false);
            alert.error("Student Record Not Found");
            setSelectedChallans([]);
            setallstudentsList([]);
            return;
          }
          searchClicked.current = true;
          searchChallanByID(data.payload[0].id);
          setSearchStudentLoading(false);
        }
      })
      .catch((err) => {
        setSearchStudentLoading(false);
        console.log("err is re", err);
      });
  };

  const searchChallanByID = (id) => {
    const data = {
      student_id: id,
      fee_month: `${fee_month}-01`,
      fee_status: 0,
    };
    fetch(`${baseUrl}/fee-challan-month-wise-single-student`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata.success) {
          if (data.payload.students.length === 0) {
            setSearchStudentLoading(false);
            alert.error("Student Record Not Found");
            setSelectedChallans([]);
            setallstudentsList([]);
            return;
          }
          searchClicked.current = true;
          setallstudentsList(data.payload.students);
          setSearchStudentLoading(false);
          setShowResult(true);
        } else if (!data.metadata.success) {
          Object.values(data.metadata.message).map((msg) => {
            alert.error(msg[0]);
          });
        }
      })
      .catch((err) => {
        setSearchStudentLoading(false);
        console.log(err);
      });
  };

  const handleOnBeforeGetContent = React.useCallback(() => {
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleMainCheckboxClick = () => {
    if (mainCheckBoxChecked) setAllCheckboxes(false);
    else setAllCheckboxes(true);
  };

  const setAllCheckboxes = (value) => {
    setmaincheckboxChecked(value);
    if (value) {
      setSelectedChallans([]);
    }

    allstudentList.map((item, i) => {
      item.checked = value;
      if (!value) {
        RemoveSelectedChallan(item);
      } else {
        AddSelectedChallan(item);
      }
    });
  };

  const checkAllCheckBoxes = () => {
    if (allstudentList.length == selectedChallans.length) {
      setmaincheckboxChecked(true);
    } else if (mainCheckBoxChecked) {
      setmaincheckboxChecked(false);
    }
  };

  const handleChallansCheckBoxClick = (e, index) => {
    allstudentList.map((item, i) => {
      if (item.id == index) {
        item.checked = !item.checked;

        if (item.checked) {
          AddSelectedChallan(item);
        } else {
          RemoveSelectedChallan(item);
        }
      }
    });
  };

  const AddSelectedChallan = (item) => {
    setSelectedChallans((prevSelectedChallans) => [
      ...prevSelectedChallans,
      item,
    ]);
  };

  const RemoveSelectedChallan = (item) => {
    setSelectedChallans((prevSelectedChallans) =>
      prevSelectedChallans.filter((std) => std.id !== item.id)
    );
  };

  const sumPayableAmount = (amount) => {
    let total = 0;
    amount.map((item) => {
      total += parseInt(item.amount);
    });
    return total;
  };
  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row col-md-12">
          <div className="col-md-3">
            <label>
              <b>Select Session</b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              onChange={(e) => setCurrentSession(e.target.value)}
              className="form-select"
              style={{ height: 40 }}
              value={currentSession}
              aria-label="Default select example"
            >
              <option value="">Select Session</option>
              {allsessions.map((session, index) => (
                <option key={index} value={session.id}>
                  {session.year}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Campus </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              onChange={(e) => onCampusChange(e.target.value)}
              className="form-select"
              style={{ backgroundColor: "white", height: 40 }}
              value={campusId}
              aria-label="Default select example"
            >
              <option value="">Select Campus</option>

              {campuses.map((campus, index) => (
                <option key={index} value={campus.id}>
                  {campus.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Course </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="course_id"
              value={courseId}
              onChange={(e) => onCourseChange(e.target.value)}
              style={{ backgroundColor: "white", height: 40 }}
              aria-label="Default select example"
            >
              <option value="">Select Course</option>
              {campusCourseData.map((item, index) => (
                <option key={index} value={item.course?.id}>
                  {item.course?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Class </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="class_id"
              value={classId}
              onChange={(e) => onClassChange(e.target.value)}
              style={{ backgroundColor: "white", height: 40 }}
              aria-label="Default select example"
            >
              <option value="">Select Class</option>
              {courseClassData.map((item, index) => (
                <option key={index} value={item.class?.id}>
                  {item.class?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3 mt-3">
            <label>
              <b>Select Section </b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="form-select form-control"
              name="section_id"
              value={sectionId}
              onChange={(e) => setSectionId(e.target.value)}
              style={{ backgroundColor: "white" }}
              aria-label="Default select example"
            >
              <option value="">Select Section</option>
              {classSectionData.map((item, index) => (
                <option key={index} value={item.section?.id}>
                  {item.section?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3 mt-3">
            <label>
              <b>Select Month</b>
            </label>
            <input
              style={{ height: 40 }}
              onChange={(e) => setfee_month(e.target.value)}
              type={"month"}
              className="form-control"
            />
          </div>
          <div className="d-flex col-md-6 mt-12">
            {loading ? (
              <button type="button" disabled={true} className="btn btn-primary">
                Searching...
              </button>
            ) : (
              <button
                type="button"
                onClick={searchChallans}
                className="btn btn-primary mr-4"
              >
                Search
              </button>
            )}

            {showResult && allstudentList.length > 0 ? (
              <ReactToPrint
                pageStyle={pageStyle}
                documentTitle="Challan Copy"
                onBeforeGetContent={handleOnBeforeGetContent}
                removeAfterPrint={true}
                trigger={() => (
                  <button
                    disabled={printloading ? true : false}
                    className="btn btn-primary mr-4"
                  >
                    {printloading ? "Printing..." : "Print Fee Challan"}
                  </button>
                )}
                content={() => componentRef.current}
              />
            ) : null}

            <div className="mt-4">
              <label className="checkbox checkbox-single">
                <input
                  type="checkbox"
                  onChange={(e) => setBlankPage(e.target.checked)}
                />
                <span />
                &nbsp;&nbsp;&nbsp;Use Blank Page For Print
              </label>
            </div>
          </div>
          <form onSubmit={searchbyAdmId}>
            <div className="row mt-5">
              <div className="col-md-4">
                <input
                  onChange={(e) => setsearchtext(e.target.value)}
                  className="form-control"
                  placeholder="Enter Admission ID"
                />
              </div>
              <div className="col-md-4">
                {searchStudentLoading ? (
                  <button
                    type="button"
                    disabled={true}
                    className="btn btn-primary"
                  >
                    Searching...
                  </button>
                ) : (
                  <button type="submit" className="btn btn-primary">
                    Search Student
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
        <Table responsive>
          <thead>
            <tr>
              <th style={{ width: "5px", textAlign: "center" }}>
                <input
                  onClick={(e) => {
                    handleMainCheckboxClick();
                  }}
                  checked={mainCheckBoxChecked}
                  style={{}}
                  placeholder="Checkbox"
                  type="checkbox"
                  readOnly
                />
              </th>
              <th style={{ textAlign: "center" }}>Challan No</th>
              <th style={{ textAlign: "center" }}>Admission Id</th>
              <th style={{ textAlign: "center" }}>Student Name</th>
              <th style={{ textAlign: "center" }}>Father Name</th>
              <th style={{ textAlign: "center" }}>Class Section</th>
              <th style={{ textAlign: "center" }}>Month</th>
              <th style={{ textAlign: "center" }}>Payable</th>
            </tr>
          </thead>
          <tbody>
            {allstudentList?.map((student, index) => (
              <tr key={student.id}>
                <td style={{ width: "5px" }}>
                  <input
                    type="checkbox"
                    value={student.id}
                    key={student.id}
                    onClick={(e) => {
                      handleChallansCheckBoxClick(e, student.id);
                    }}
                    checked={student.checked ?? false}
                    style={{ border: "10px" }}
                    readOnly
                  ></input>
                </td>
                <td style={{ textAlign: "center" }}>
                  {student?.fee_challans_detials[0]?.fee_challan_id}
                </td>
                <td style={{ textAlign: "center" }}>{student.admission_id}</td>
                <td
                  title={student?.name}
                  style={{ textAlign: "center", cursor: "pointer" }}
                >
                  {student?.name}
                </td>
                <td
                  title={student?.father_name}
                  style={{ textAlign: "center", cursor: "pointer" }}
                >
                  {student?.father_name}
                </td>

                <td style={{ textAlign: "center" }}>
                  {student?.student_class?.name}&nbsp;
                  {student?.global_section?.name}&nbsp; ({student?.campus?.name}
                  )
                </td>
                <td style={{ textAlign: "center" }}>
                  {getMonthName(student?.fee_challans_detials[0]?.fee_month)}
                </td>

                <td style={{ textAlign: "center" }}>
                  {sumPayableAmount(student?.fee_challans_detials)}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        <div className="row justify-content-center">
          {(loading || searchStudentLoading) && (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          )}
        </div>
      </Paper>

      <div ref={componentRef} id="printSection" className="customTablePrint">
        <MultiStudentFeeChallan
          allstudentList={
            allstudentList.length == selectedChallans.length
              ? allstudentList
              : selectedChallans
          }
          blankPage={blankPage}
        />
      </div>
    </>
  );
};

export default SingleStudentMonth;
